import React from 'react';
import Button from '../../ui/Button';
import { Check } from 'lucide-react';

const MarketerPricing: React.FC = () => {
  return (
    <section id="pricing" className="py-24 bg-slate-950">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold text-white mb-4">Transparent Pricing</h2>
          <p className="text-slate-400">14-day free trial. No credit card required. Cancel anytime.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          
          {/* STARTER */}
          <div className="bg-slate-900 border border-slate-800 rounded-2xl p-8 flex flex-col">
            <h3 className="text-xl font-bold text-white mb-2">Starter</h3>
            <div className="flex items-baseline mb-6">
              <span className="text-4xl font-bold text-white">$99</span>
              <span className="text-slate-500 ml-1">/mo</span>
            </div>
            <p className="text-sm text-slate-400 mb-8 border-b border-slate-800 pb-8">Perfect for solo consultants and small teams just starting out.</p>

            <ul className="space-y-4 mb-8 flex-1">
              <li className="flex items-center text-sm text-slate-300">
                <Check className="w-4 h-4 text-emerald-500 mr-3" />
                500 Credits / mo
              </li>
              <li className="flex items-center text-sm text-slate-300">
                <Check className="w-4 h-4 text-emerald-500 mr-3" />
                Basic Filtering
              </li>
              <li className="flex items-center text-sm text-slate-300">
                <Check className="w-4 h-4 text-emerald-500 mr-3" />
                Standard Support
              </li>
              <li className="flex items-center text-sm text-slate-500">
                <span className="w-4 h-4 mr-3"></span>
                $0.20 / extra credit
              </li>
            </ul>
            <Button variant="secondary" className="w-full">Start Trial</Button>
          </div>

          {/* GROWTH */}
          <div className="bg-slate-900 border border-sky-500 rounded-2xl p-8 flex flex-col relative transform md:scale-105 shadow-2xl shadow-sky-900/20">
            <div className="absolute top-0 right-0 bg-sky-500 text-white text-xs font-bold px-3 py-1 rounded-bl-lg rounded-tr-lg">MOST POPULAR</div>
            <h3 className="text-xl font-bold text-white mb-2">Growth</h3>
            <div className="flex items-baseline mb-6">
              <span className="text-4xl font-bold text-white">$249</span>
              <span className="text-slate-500 ml-1">/mo</span>
            </div>
            <p className="text-sm text-slate-400 mb-8 border-b border-slate-800 pb-8">For growing agencies and recruiters scaling their outreach.</p>

            <ul className="space-y-4 mb-8 flex-1">
              <li className="flex items-center text-sm text-white font-medium">
                <Check className="w-4 h-4 text-sky-500 mr-3" />
                2,500 Credits / mo
              </li>
              <li className="flex items-center text-sm text-white font-medium">
                <Check className="w-4 h-4 text-sky-500 mr-3" />
                Full API Access
              </li>
              <li className="flex items-center text-sm text-white font-medium">
                <Check className="w-4 h-4 text-sky-500 mr-3" />
                Priority Support
              </li>
              <li className="flex items-center text-sm text-white">
                <Check className="w-4 h-4 text-sky-500 mr-3" />
                $0.10 / extra credit
              </li>
            </ul>
            <Button variant="primary" className="w-full">Start Free Trial</Button>
          </div>

          {/* AGENCY */}
          <div className="bg-slate-900 border border-slate-800 rounded-2xl p-8 flex flex-col">
            <h3 className="text-xl font-bold text-white mb-2">Agency</h3>
            <div className="flex items-baseline mb-6">
              <span className="text-4xl font-bold text-white">$499</span>
              <span className="text-slate-500 ml-1">/mo</span>
            </div>
            <p className="text-sm text-slate-400 mb-8 border-b border-slate-800 pb-8">High volume access for lead generation firms and large teams.</p>

            <ul className="space-y-4 mb-8 flex-1">
              <li className="flex items-center text-sm text-slate-300">
                <Check className="w-4 h-4 text-emerald-500 mr-3" />
                10,000 Credits / mo
              </li>
              <li className="flex items-center text-sm text-slate-300">
                <Check className="w-4 h-4 text-emerald-500 mr-3" />
                Full API Access
              </li>
              <li className="flex items-center text-sm text-slate-300">
                <Check className="w-4 h-4 text-emerald-500 mr-3" />
                White Label Reports
              </li>
              <li className="flex items-center text-sm text-slate-300">
                <Check className="w-4 h-4 text-emerald-500 mr-3" />
                $0.05 / extra credit
              </li>
            </ul>
            <Button variant="secondary" className="w-full">Contact Sales</Button>
          </div>

        </div>
      </div>
    </section>
  );
};

export default MarketerPricing;